import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Alert,
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Spinner,
  Table,
} from 'reactstrap';

import { get } from '../../helpers/api_helper';

document.title = 'Google Merchant Utilities';

function displayValue(value, t) {
  if (value === null || value === undefined || value === '') {
    return t('Not configured');
  }

  return value;
}

function GoogleMerchant(props) {
  const { t } = props;
  const [information, setInformation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    get('/api/google/merchant')
      .then((result) => {
        if (mounted) {
          setInformation(result);
        }
      })
      .catch((requestError) => {
        if (mounted) {
          setError(requestError.message);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="7">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Google Merchant Utilities')}
              </CardHeader>
              <CardBody>
                {error !== null && <Alert color="danger">{error}</Alert>}

                {information === null && error === null && (
                  <div className="d-flex align-items-center gap-2">
                    <Spinner size="sm" />
                    <span>{t('Loading Google Merchant configuration')}</span>
                  </div>
                )}

                {information !== null && (
                  <>
                    <Alert color="info">
                      {t('Product publishing and inventory controls will be added here.')}
                    </Alert>

                    <Table bordered striped responsive>
                      <tbody>
                        <tr>
                          <th scope="row">{t('Status')}</th>
                          <td>
                            <Badge
                              color={information.configured ? 'success' : 'warning'}
                              className={information.configured ? '' : 'google-merchant-status-warning'}
                            >
                              {information.configured ? t('Configured') : t('Needs configuration')}
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Account ID')}</th>
                          <td>{displayValue(information.account_id, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Data Source ID')}</th>
                          <td>{displayValue(information.data_source_id, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Listing Channel')}</th>
                          <td>{displayValue(information.channel, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Taxonomy Tree')}</th>
                          <td>{displayValue(information.taxonomy_tree_key, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Content Language')}</th>
                          <td>{displayValue(information.content_language, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Feed Label')}</th>
                          <td>{displayValue(information.feed_label, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Currency')}</th>
                          <td>{displayValue(information.currency_code, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Products API Version')}</th>
                          <td>{displayValue(information.products_api_version, t)}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t('Service Account Key')}</th>
                          <td>
                            {information.authentication?.key_file_exists
                              ? t('Available')
                              : t('Missing')}
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                    {information.missing_config?.length > 0 && (
                      <Alert color="warning" className="mb-0">
                        {t('Missing configuration:')}
                        {' '}
                        {information.missing_config.join(', ')}
                      </Alert>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

GoogleMerchant.defaultProps = {
  t: (value) => value,
};

GoogleMerchant.propTypes = {
  t: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(GoogleMerchant));
